<template>
  <div class="row align-items-start justify-content-center" :class="{ 'flex-column': isMobile }">
    <div class="col-md-6 my-2" :class="{'w-100': isMobile}" v-if="hasMediaOriginals && media.download_hd_url">
      <ButtonDownloadPhoto :media="media"
                           :quality="mediaQuality.HD"
                           :dt-photos-hd-available-formatted="hdAvailableFrom|formatDate"
                           :label="$t('collage_photo_item.hd_size')"
                           @click="onClick"/>
    </div>
    <div class="col-md-6 my-2" :class="{'w-100': isMobile}">
      <ButtonDownloadPhoto :media="media"
                           :quality="mediaQuality.SD"
                           @click="onClick"/>
    </div>
  </div>
</template>
<script>
import ButtonDownloadPhoto from "@/components/ButtonDownloadPhoto.vue";
import {mediaQuality} from "@/domain/galleries/constants";
import {mapGetters} from "vuex";

export default {
  name: "DownloadActions",
  components: {ButtonDownloadPhoto},
  emits: ['click'],
  props: {
    media: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', [
      'hasMediaOriginals',
      'hdAvailableFrom'
    ]),
    mediaQuality() {
      return mediaQuality
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>


<style scoped>

</style>